// Günlük program — hesaplanmamış (eksik metrik) servis listesi.
// Görünüm: Sürücü Puantajı detay modalındaki eksik metrik satırları ile aynı.

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Modal from "shared/components/UIElements/Modal";
import Button from "shared/components/FormElements/Button";

import ServiceMetricsRow from "./performance/components/ServiceMetricsRow";

import "./performance/DriverPerformance.css";
import "./UncomputedServicesModal.css";

const ISSUE_SORT_RANK = {
  UNASSIGNED: 0,
  NO_PASSENGERS: 1,
  MISSING_METRICS: 2,
};

const sortScheduleExceptions = (services) =>
  [...services].sort((a, b) => {
    const ia = ISSUE_SORT_RANK[a.issueType] ?? 99;
    const ib = ISSUE_SORT_RANK[b.issueType] ?? 99;
    if (ia !== ib) return ia - ib;
    return (a.name || "").localeCompare(b.name || "", "tr");
  });

const UncomputedServicesModal = ({ show, onClose, date, services = [] }) => {
  const { t } = useTranslation();
  const sortedServices = useMemo(() => sortScheduleExceptions(services), [services]);
  const count = sortedServices.length;
  const unassignedCount = sortedServices.filter((s) => s.issueType === "UNASSIGNED").length;
  const noPassengersCount = sortedServices.filter((s) => s.issueType === "NO_PASSENGERS").length;
  const missingCount = sortedServices.filter((s) => s.issueType === "MISSING_METRICS").length;

  return (
    <Modal
      show={show}
      onCancel={onClose}
      className="uncomputed-services-modal-dialog"
      contentClass="uncomputed-services-modal-dialog__content"
      header={t("driverScheduler.uncomputedModal.title", { count })}
      footer={<Button onClick={onClose}>{t("driverScheduler.uncomputedModal.close")}</Button>}
    >
      <div className="uncomputed-services-modal">
        <p className="uncomputed-services-modal__intro">{t("driverScheduler.uncomputedModal.intro")}</p>
        {date && (
          <p className="uncomputed-services-modal__date">
            {t("driverScheduler.date")}: <strong>{date}</strong>
          </p>
        )}
        <div className="dp-day dp-day--has-missing uncomputed-services-modal__list">
          <div className="dp-day__header">
            <span className="dp-day__stats">
              {count} {t("driverPerformance.servicesShort")}
              {unassignedCount > 0 && (
                <span className="dp-tag dp-tag--warn dp-day__missing-tag" title={t("driverScheduler.unassignedIssueHint")}>
                  {unassignedCount} {t("driverScheduler.unassignedIssueTag")}
                </span>
              )}
              {noPassengersCount > 0 && (
                <span className="dp-tag dp-tag--warn dp-day__missing-tag" title={t("driverScheduler.noPassengersIssueHint")}>
                  {noPassengersCount} {t("driverScheduler.noPassengersIssueTag")}
                </span>
              )}
              {missingCount > 0 && (
                <span className="dp-tag dp-tag--warn dp-day__missing-tag" title={t("driverPerformance.metricsMissingHint")}>
                  {missingCount} {t("driverPerformance.metricsMissing")}
                </span>
              )}
            </span>
          </div>
          <div className="dp-day__services">
            {sortedServices.map((service) => (
              <ServiceMetricsRow key={service.serviceId} service={service} t={t} />
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UncomputedServicesModal;
